/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import API from '../config';

const asyncTimeout = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms));

const mockFactory = async (url, { ms = 350, response = {} }) => {
  console.warn(`Mocking: ${API.URL}${url}`);
  await asyncTimeout(ms);
  console.warn('mock response: ', response);
  return response;
};

const Mock = {
  Get: mockFactory,
  Put: mockFactory,
  Del: mockFactory,
  Post: mockFactory,
};

export default Mock;
